let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("abBPE")).then(() => parcelRequire('BMgPz'));